import { takeEvery, put, call, fork } from 'redux-saga/effects';
import { Client } from 'utils/client';
import {
    HELPER_TRANSACTION_STATUS_ONLOAD,
    transactionStatusSuccess,
    HELPER_COMMON1_ONLOAD,
    common1Success,
    HELPER_COUNTRIES_ONLOAD,
    countriesSuccess,
    HELPER_FLOW_INFO_ONLOAD,
    flowInfoSuccess,
    HELPER_PAYMENT_MODES_ONLOAD,
    paymentModesSuccess
} from './actions';

export function* transactionStatusOnLoad(action) {
    try {
        const data = yield call(Client.getData, '/api/v1/remittances/transactions/status');
        yield put(transactionStatusSuccess(data));
    } catch (error) {
        console.log(error);
    }
}

export function* common1OnLoad(action) {
    try {
        // const data = yield call(Client.getData, 'http://localhost:8096/api/v1/products/portal/helperlist');
        const data = yield call(Client.getData, '/api/v1/products/helperlist');
        yield put(common1Success(data));
    } catch (error) {
        console.log(error);
    }
}

export function* countriesOnLoad(action) {
    try {
        const data = yield call(Client.getData, '/api/v1/utility/receivingcountries');
        yield put(countriesSuccess(data));
    } catch (error) {
        console.log(error);
    }
}

export function* paymentModesOnLoad(action) {
    try {
        const data = yield call(Client.getData, '/api/v2/products/source-of-funds');
        yield put(paymentModesSuccess(data));
    } catch (error) {
        console.log(error);
    }
}


export function* flowInfoOnLoad(action) {
    try {
        const data = yield call(Client.getData, '/api/v1/portal/flows');
        yield put(flowInfoSuccess(data));
    } catch (error) {
        console.log(error);
    }
}

function* watchHelperApis() {
    yield takeEvery(HELPER_TRANSACTION_STATUS_ONLOAD, transactionStatusOnLoad);
    yield takeEvery(HELPER_COMMON1_ONLOAD, common1OnLoad);
    yield takeEvery(HELPER_COUNTRIES_ONLOAD, countriesOnLoad);
    yield takeEvery(HELPER_PAYMENT_MODES_ONLOAD, paymentModesOnLoad);
    yield takeEvery(HELPER_FLOW_INFO_ONLOAD, flowInfoOnLoad);
}

export function* helperSaga() {
    yield fork(watchHelperApis);
}
